export class SwitchLanguageModel {
    AccessToken: string;
    DatabaseName: string;
    Language: string;
}